<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-gailan`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_e3213d4e22__clip0_1270_210637)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 1.875C2.21079 1.875 1.875 2.21079 1.875 2.625V7.5C1.875 7.91421 2.21079 8.25 2.625 8.25H7.5C7.91421 8.25 8.25 7.91421 8.25 7.5V2.625C8.25 2.21079 7.91421 1.875 7.5 1.875H2.625ZM3.375 6.75V3.375H6.75V6.75H3.375ZM10.5 1.875C10.0858 1.875 9.75 2.21079 9.75 2.625V7.5C9.75 7.91421 10.0858 8.25 10.5 8.25H15.375C15.7892 8.25 16.125 7.91421 16.125 7.5V2.625C16.125 2.21079 15.7892 1.875 15.375 1.875H10.5ZM11.25 6.75V3.375H14.625V6.75H11.25ZM1.875 10.5C1.875 10.0858 2.21079 9.75 2.625 9.75H7.5C7.91421 9.75 8.25 10.0858 8.25 10.5V15.375C8.25 15.7892 7.91421 16.125 7.5 16.125H2.625C2.21079 16.125 1.875 15.7892 1.875 15.375V10.5ZM3.375 11.25V14.625H6.75V11.25H3.375ZM10.5 9.75C10.0858 9.75 9.75 10.0858 9.75 10.5V15.375C9.75 15.7892 10.0858 16.125 10.5 16.125H15.375C15.7892 16.125 16.125 15.7892 16.125 15.375V10.5C16.125 10.0858 15.7892 9.75 15.375 9.75H10.5ZM11.25 14.625V11.25H14.625V14.625H11.25Z"/></g><defs><clipPath id="svg_e3213d4e22__clip0_1270_210637"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconGailan',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
